import { Data } from 'signup-constants/signupData/Data';
import { UseCase } from 'signup-constants/signupData/UseCaseOption';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { DataOptions, UseCaseToHubInterest } from '../signup-data/signupDataOptions';
import { useSignupData } from '../signup-data/useSignupData';
import { BaseButtonsView } from './BaseButtonsView';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { getHighestPriorityUseCase } from '../experiments/coac-0001/COAC001Utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const isUseCaseButtonDisabled = (data, key) => {
  return data.split(',').length === 3 && !data.includes(key);
};
export const getUseCaseDataWithoutKey = (useCaseData, key) => {
  const useCaseList = useCaseData.split(',');
  const useCaseListWithoutSelectedKey = useCaseList.filter(useCaseKey => useCaseKey !== key);
  const filteredData = useCaseListWithoutSelectedKey.join(',');
  return filteredData;
};
const UseCaseView = () => {
  const dataKey = Data.UseCase;
  const {
    isMobile,
    isDesktop
  } = useResponsiveness();
  let options = DataOptions[dataKey];
  const {
    data
  } = useSignupData(dataKey);
  const {
    setData: setHubInterest
  } = useSignupData(Data.HubInterest);
  const {
    isAssignedToVariant: isAssignedACQ145Variant
  } = useExperiment(ExperimentKeys.ACQ0145, TrackWhen.never);
  const {
    isAssignedToVariant: isAssignedCOAC0001Variant
  } = useExperiment(ExperimentKeys.COAC0001, TrackWhen.never);
  if (isAssignedCOAC0001Variant()) {
    options = options.filter(val => val !== UseCase.BuildWebsite && val !== UseCase.MarketingContent);
  }
  const isSelected = key => {
    return data.includes(key);
  };
  const setDataFn = (key, setData) => {
    let useCaseData = data;
    if (isSelected(key)) {
      useCaseData = getUseCaseDataWithoutKey(useCaseData, key);
    } else if (key === UseCase.StillExploring) {
      useCaseData = UseCase.StillExploring;
    } else {
      useCaseData = getUseCaseDataWithoutKey(useCaseData, UseCase.StillExploring);
      useCaseData = useCaseData ? useCaseData.concat(`,${key}`) : key;
    }
    setData(useCaseData);
  };
  const onSelect = () => {
    if (isAssignedCOAC0001Variant()) {
      const useCases = data.split(',');
      const highestPriorityUseCase = getHighestPriorityUseCase(useCases);
      if (highestPriorityUseCase) {
        const hubInterestMapping = UseCaseToHubInterest[highestPriorityUseCase];
        if (hubInterestMapping) {
          setHubInterest(hubInterestMapping);
        }
      }
    }
  };
  let columnCount = isMobile ? 1 : 2;
  if (isAssignedCOAC0001Variant()) {
    columnCount = isDesktop ? 3 : 1;
  }
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    columnCount: columnCount,
    hasNextButton: true,
    helperTextString: isAssignedACQ145Variant() ? 'views.USE_CASE.helperText_new' : 'views.USE_CASE.helperText',
    isSelected: isSelected,
    options: options,
    setDataFn: setDataFn,
    shouldCenterLastRow: false,
    shouldDisableAutofocus: true,
    type: "checkbox",
    onSelect: onSelect
  });
};
export default UseCaseView;